<template>
  <CRow class="w-100" style="min-heigth: 100px">
    <CCol sm="4" class="imageTemplate h-100">
      <div class="imageTemplate__actions">
        <CButton color="transparent" @click="goToEditor()" class="imageTemplate__button">{{ $t('automation.image.template.action.001') }}</CButton>
      </div>
      <img :src="templateImage" :alt="templateName" style="min-heigth: 300px" />
    </CCol>
    <CCol sm="6" class="d-flex flex-column justify-content-center">
      <span class="font-weight-bold d-block">{{ templateName }}</span>
      <span class="font-sm text-gray-600">{{ daysAgoTranslation }}</span>
    </CCol>
    <CCol sm="2" class="text-center d-flex align-items-center">
      <span @click="emitRemoveTemplate" class="font-weight-bold mx-auto text-underline cursor-pointer text-primary">Remover</span>
    </CCol>
  </CRow>
</template>

<script>
import { DateTime } from 'luxon'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants.js'

export default {
  name: 'AutomationImageTemplate',

  props: {
    template: {
      type: Object,
      require: true,
    },
  },

  computed: {
    templateImage() {
      return this.template.thumbnailUri || `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.template.templateId}/thumbnail.jpg`
    },

    templateName() {
      return this.template.templateName
    },

    htmlFileUri() {
      return this.template.htmlFileUri || `${this.$configs.VUE_APP_ROOT_API}template/email/static/${this.template.templateId}/index.html`
    },

    createdDays() {
      const luxonCreatedDate = DateTime.fromISO('2024-02-09T13:25:35.541245')
      const currentDateTime = DateTime.now()

      const diffBetweenDates = currentDateTime.diff(luxonCreatedDate, 'days').days
      const formattedDiff = Math.floor(diffBetweenDates)

      return Math.max(0, formattedDiff)
    },

    daysAgoTranslation() {
      if (this.createdDays > 0) return this.$t('automation.image.template.created.days-ago', this.createdDays)
      return this.$t('automation.image.template.created.days.today')
    },
  },

  methods: {
    emitRemoveTemplate() {
      this.$emit('removeTemplate')
    },
    goToEditor() {
      const params = {
        contentType: this.template.contentType,
        dynamicDestinationType: DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW,
        dynamicId: this.$route.params.workflowId,
        dynamicIndex: this.template.indexStep,
      }

      if (this.template.isUnlayer) {
        params.templateId = this.template.templateId
        return this.$router.push({
          name: 'unlayer',
          params,
          hash: this.$route.hash,
        })
      }

      params.id = this.template.templateId
      return this.$router.push({
        name: 'edit-template-html',
        params,
        hash: this.$route.hash,
      })
    },
  },
}
</script>

<style lang="scss">
.imageTemplate {
  position: relative;

  &:hover {
    .imageTemplate__actions {
      cursor: initial;
      background: rgba($primary, 0.1);
      border: 1px solid $primary;
    }

    img,
    p {
      opacity: 0.15;
    }

    .imageTemplate__button {
      opacity: 1;
      color: $primary;
      cursor: pointer;
    }
  }

  &__actions {
    // #ffede7
    background: transparent;
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-self: center;
    align-items: center;
    transition: 300ms;
    z-index: 1;
    right: 0;
  }

  img {
    transition: 300ms;
  }

  &__button {
    opacity: 0;
    font-family: 14px;
    text-transform: uppercase;
    display: inline-flex;
    transition: 300ms;
  }
}
</style>
